import { render, staticRenderFns } from "./_penjualan.vue?vue&type=template&id=71308ce7&"
import script from "./_penjualan.vue?vue&type=script&lang=js&"
export * from "./_penjualan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports